import { IoLogOutOutline } from "react-icons/io5";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { useI18n } from "@/i18n";

export const LogoutDialog = ({ open, onOpenChange, onConfirm }) => {
  const { t } = useI18n();
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="logout-dialog" className="max-w-sm p-0" style={{ borderRadius: 20 }}>
        <div className="tf-modal-content">
          <div className="tf-modal-icon">
            <IoLogOutOutline size={36} />
          </div>
          <div className="tf-modal-title">{t("exit_confirm_title")}</div>
          <p className="tf-modal-desc">{t("exit_confirm_desc")}</p>
          <button data-testid="logout-confirm" className="tf-btn-primary sq" onClick={onConfirm}>
            <IoLogOutOutline size={18} />
            {t("exit")}
          </button>
          <button data-testid="logout-cancel" className="tf-modal-cancel" onClick={() => onOpenChange(false)}>
            {t("cancel")}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
